import Wordmark from './Wordmark'

export default Wordmark
